// extracted by mini-css-extract-plugin
module.exports = {"initials":"_3YE1bPvCvGGpxVgFJ5GS_j","gridItemImage":"_1-Ue3oiF6HVBXDefQZNGQt","letter":"z2SYacwZvTHNxGK1v1dPG"};